export class  LoaderHandler {
    endPointName!: string;
    componentName!: string;
  }